import React from 'react'
import { useStyles } from './ListingDesignForm.styles'
import { ListingDesignFormCards } from '../ListingDesignFormCards/ListingDesignFormCards'
import { TemplateCardButtons } from '../../TemplateCreationFormikWrapper/TemplateCardButtons/TemplateCardButtons'
export const ListingDesignForm: React.FC = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <TemplateCardButtons />
      <div className={classes.designCards}></div>
      <ListingDesignFormCards />
    </div>
  )
}
